import ZrLogo from '@assets/svg/ZrLogo';
import { useAppRouter } from '@my-medication/shared-components/providers/AppRouterProvider';
import { AdminPortalKeys, Namespace } from '@i18n/translations';
import { type FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const LoginIntro: FunctionComponent = () => {
  const { t } = useTranslation(Namespace.AdminPortal);
  const { navigateTo, resolveRoute } = useAppRouter();
  const href = resolveRoute({ name: 'Admin Login' }).href;

  return (
    <div className="my-12.5 text-center">
      <a
        href={href}
        onClick={(e) => {
          e.preventDefault();
          navigateTo({ name: 'Admin Login' });
        }}
        className="text-secondary-900 no-underline"
      >
        <ZrLogo className="mx-auto h-auto w-45 s:w-68.75" role="img" aria-label={t(AdminPortalKeys.Header_LogoAlt)} />
      </a>
      <h1 className="m-0 mt-3.75 text-base font-normal uppercase s:mt-6.25 s:text-xl">
        {t(AdminPortalKeys.Login_PageClaim)}
      </h1>
    </div>
  );
};

LoginIntro.displayName = 'LoginIntro';

export { LoginIntro };
